import { render } from "./ContentFileUploadExtended.vue?vue&type=template&id=f83b6e56"
import script from "./ContentFileUploadExtended.vue?vue&type=script&lang=js"
export * from "./ContentFileUploadExtended.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__